import { render, staticRenderFns } from "./comment-table-item.vue?vue&type=template&id=63c6aec3&scoped=true"
import script from "./comment-table-item.vue?vue&type=script&lang=js"
export * from "./comment-table-item.vue?vue&type=script&lang=js"
import style0 from "./comment-table-item.vue?vue&type=style&index=0&id=63c6aec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6aec3",
  null
  
)

export default component.exports